import { makeStyles, Table, TableHead, TableBody, TableRow, TableCell, Typography } from "@material-ui/core";
import React from 'react';
import LinhaAmostrasLote from './LinhaAmostrasLote';
import MensagemListagemVazia from "../../../shared/components/MensagemListagemVazia";
import { LISTAGEM_VAZIA_AMOSTRAS_DISPONIVEIS, LISTAGEM_VAZIA_AMOSTRAS_NO_LOTE, LISTAGEM_VAZIA_FILTROS } from "../../../shared/utils/Constantes";
import IconeCodigoBarras from "../../../shared/components/IconeCodigoBarras";

const ListaAmostrasLote = ({
    listaAmostrasLote,
    handleInserirAmostra,
    handleExcluirAmostra,
    selecionandoAmostras,
    filtrando
}) => {

    const classes = useStyles();

    const definirMensagemListagemVazia = () => {
        if (filtrando) {
            return LISTAGEM_VAZIA_FILTROS;
        }
        else if (selecionandoAmostras) {
            return LISTAGEM_VAZIA_AMOSTRAS_DISPONIVEIS;
        }
        else {
            return LISTAGEM_VAZIA_AMOSTRAS_NO_LOTE;
        }
    }

    const mensagemListagemVazia = definirMensagemListagemVazia();

    const handleClickIconeAcao = (id, codigo) => {
        if (selecionandoAmostras) {
            handleInserirAmostra(id);
        }
        else {
            handleExcluirAmostra(id, codigo);
        }
    }

    return (
        <>
            <Table stickyHeader size={"small"} className={classes.root}>
                <TableHead>
                    <TableRow className={classes.header}>
                        <TableCell className={classes.colunaEtiqueta} size={"small"} align="left">
                            <Typography variant={"body2"}>Amostra</Typography>
                        </TableCell>
                        <TableCell className={classes.colunaTipoAmostra} size={"small"} align="left">
                            <Typography variant={"body2"}>Tipo</Typography>
                        </TableCell>
                        <TableCell padding="none" />
                        <TableCell className={classes.colunaConservacao} size={"small"} align="left">
                            <Typography variant={"body2"}>Conservação</Typography>
                        </TableCell>
                        <TableCell className={classes.colunaNumeroPedido} size={"small"} align="left">
                            <Typography variant={"body2"}>Pedido</Typography>
                        </TableCell>
                        <TableCell className={classes.colunaNomePaciente} size={"small"} align="left">
                            <Typography variant={"body2"}>Paciente</Typography>
                        </TableCell>
                        <TableCell padding="none" />
                        <TableCell className={classes.colunaAcoes} size={"small"} align="left">
                            <Typography variant={"body2"}>Ações</Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {listaAmostrasLote && listaAmostrasLote.map((item, index) => (
                        <LinhaAmostrasLote
                            key={item.codigo + index.toString()}
                            item={item}
                            index={index}
                            handleClickIconeAcao={handleClickIconeAcao}
                            selecionandoAmostras={selecionandoAmostras}
                        />
                    ))}
                </TableBody>
            </Table>
            {
                listaAmostrasLote && listaAmostrasLote.length === 0 &&
                <MensagemListagemVazia
                    mensagem={mensagemListagemVazia}
                    iconeCustom={
                        !selecionandoAmostras && !filtrando
                            ? (props) => <IconeCodigoBarras exibirCirculo {...props} />
                            : null
                    }
                />
            }
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: "99%",
        "& #form": {
            left: "-52px",
        },
        "& #form > div > div": {
            boxShadow: "none",
            borderStyle: "none",
        },
        "& .MuiBadge-root": {
            width: "5px",
        },
    },

    header: {
        height: "7vh",
    },

    fontRowHeader: {
        fontSize: "16px",
    },

    colunaEtiqueta: { width: "160px" },
    colunaTipoAmostra: { width: "200px" },
    colunaConservacao: { width: "150px" },
    colunaNumeroPedido: { width: "120px" },
    colunaNomePaciente: { width: "200px" },
    colunaAcoes: { width: "100px" },
}))

export default ListaAmostrasLote;